<template>
    <wrapper>
        <main class="main-content-wrapper">
            <disposal-form
                title="Tambah Disposal Baru"
                subtitle="Harap isi rincian disposal barang berikut dengan lengkap."
                :form-data="formData"
                :channel-type-options="channelTypeOptions"
                :loading-btn-get-data="loadingBtnGetData"
                :validation-status="validationStatus"
                :loading-revalidate="loadingRevalidate"
                :status-badge="formData.statusDisposal"
                :validation-show-action="false"
                :show-validation-progress="false"
                @ambil-data="ambilData()"
            />

            <div class="mt-3 d-flex justify-content-between">
                <button class="btn btn-outline-secondary back-btn" @click="$router.back()">
                    &#8592; Kembali
                </button>
            </div>
        </main>
    </wrapper>
</template>

<script>
import { Wrapper } from '../Layout';
import DisposalForm from './CustomComponent/DisposalForm.vue';
import Swal from "sweetalert2";
import { alert } from "@/utils/alert";

export default {
    name: 'DisposalCreationPage',
    components: {
        Wrapper,
        DisposalForm,
    },
    data() {
        return {
            loadingBtnGetData: false,
            loadingBtnSubmit: false,
            loadingRevalidate: false,
            allowCreateDisposal:false,
            allowUpdateDisposal: false,
            allowDeleteDisposal:false,
            validationStatus: {
                total: 13,
                validated: 13,
                isValid:false,
                failedItems: [],
            },
            formData: {
                channel: 'Marketplace',
                channelType: '',
                disposalDate: '',
                trxId: '',
                salesInvoiceId: '',
                items: [],
                accessories: [],
            },
            channelTypeOptions: [],
        };
    },
    computed: {
        isFormComplete() {
            return (
                this.formData.channel.trim() !== '' &&
                this.formData.channelType.trim() !== '' &&
                this.formData.disposalDate.trim() !== '' &&
                this.formData.trxId.trim() !== ''
            );
        },
    },
    methods: {
        getChannelTypes() {
            this.$http.get(process.env.DISPOSAL_GET_CHANNEL_TYPES,
            {
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                } else {
                   this.channelTypeOptions = response.data.data.marketplaces.map(marketplace => ({
                        type: marketplace,
                        typeName: marketplace,
                    }))
                }
                })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    } 
                })
            })
        },
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",") 
            if(!this.permission.includes('26.1')) {
                this.$router.push('/');
            }
            if(this.permission.includes('26.2')) {
                this.allowUpdateDisposal = true
            }
            if(this.permission.includes('26.3')) {
                this.allowCreateDisposal = true
            }
            if(this.permission.includes('26.4')) {
                this.allowDeleteDisposal = true
            }
        },
        toInputDate(value) {
            if (!value) return '';
            const [day, month, year] = value.split('-');
            return `${year}-${month}-${day}`;
        },
        ambilData(isRevalidation = false) {
            this.loadingBtnGetData = true;
            this.$http.post(process.env.GET_DISPOSAL_DATA_FROM_SHEET,{
                    channel : this.formData.channel,
                    marketplace: this.formData.channelType,
                    date: this.formData.disposalDate,
                    orderIdMarketPlace: this.formData.trxId,
                },{
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                    this.loadingBtnGetData = false
                    if (isRevalidation) this.loadingRevalidate = false
                } else {
                    // this.getDetailData(response.data.data.disposalId, isRevalidation)
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Success",
                        text: `Berhasil menyimpan data disposal.`,
                        icon: "success",
                    }).then((result) => {
                        this.loadingBtnGetData = false
                        this.getDetailData(response.data.data.disposalId, isRevalidation)
                    });
                //    console.log(response.data.data.disposalId)
                }
                })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    } else {
                        this.loadingBtnGetData= false
                        if (isRevalidation) this.loadingRevalidate = false
                    }
                })
            })
        },
        toDisposalDetailPage(id, code){
            this.$router.push({
                path: `/disposal/${id}`, 
                query: {
                    code : code
                }  
            })
        },
        getDetailData(disposeId, isRevalidation = false) {
            this.loadingBtnGetData= true
            this.$http
                .get(process.env.GET_DISPOSAL_DETAIL + disposeId, {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                })
                .then((response) => {
                    console.log(response.data.data)
                    if (response.data.status === 200) {
                        const content = response.data.data;
                        this.formData = {
                            channel: content.channel === 'marketplace' ? 'Marketplace' : content.channel || '',
                            channelType: content.marketplace || '',
                            disposalDate: this.toInputDate(content.disposeDate),
                            trxId: content.invoiceMarketplace || '',
                            salesInvoiceId: content.salesInvoiceId || '',
                            statusDisposal: content.statusDisposal || '',
                            items: (content.items || []).map((item) => ({
                                name: item.itemName,
                                rows: (item.units || []).map((unit) => ({
                                    serialNumber: unit.serialNumber,
                                    assetId: unit.assetId,
                                    statusJurnal: unit.statusJurnal,
                                })),
                            })),
                            accessories: (content.accessories || []).map((accessory) => ({
                                name: accessory.itemName,
                                qty: accessory.qty,
                            })),
                        };
                        this.validationStatus.failedItems = [...content.invalidItems]
                        this.validationStatus.isValid = content.isValid

                        this.toDisposalDetailPage(content.id, content.disposalCode)
                    }
                    this.loadingBtnGetData= false
                })
                .catch((error) => {
                    this.loadingBtnGetData= false
                    const message =
                        (error.response && error.response.data && error.response.data.message) ||
                        'Gagal memuat data disposal';
                    swal('Sorry', message, 'error', { button: 'Ok' }).then(() => {
                        if (error.response && error.response.data && error.response.data.status === 401) {
                            this.handleLogout();
                        }
                    });
                });
        },
        toDisposalPage() {
            this.$router.push({
                path: '/disposal',
                query: {
                    disposalId: '',
                    disposalDate: '',
                    createdBy: '',
                    erpTrxId: '',
                    jurnalTrxId: '',
                    status: '',
                    page: 1,
                    itemPerPage: 10,
                }
            })
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/');
            }
        },
    },
    created() {
        this.cekLogin();
        this.cekPermission()
        this.getChannelTypes()
    },
};
</script>

<style scoped>
.main-content-wrapper {
    padding: 24px;
}

.back-btn {
    font-size: 13px;
    border-color: #dee2e6;
    color: #343a40;
    background: #fff;
    padding: 6px 16px;
}

.back-btn:hover {
    background-color: #f8f9fa;
}

.submit-btn {
    font-size: 13px;
    padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Disposal/DisposalCreationPage.vue